/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Badge, Box, Grid, styled, Typography } from "@mui/material";

import { getUsersById } from "../../../services/api/apiManager";
import { settings as s } from "../../../services/Settings";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "@mui/material";

function UserProfile() {
  const dispatch = useDispatch();
  const { device } = useSelector((state) => state.call);
  const [showProfileHead, setShowProfileHead] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showProfileInfo, setShowProfileInfo] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)"); // Detect mobile screen
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  // get userId from Local storage
  const getUserId = localStorage.getItem("user_id");
  // api get data by id
  const getData = async (data) => {
    try {
      const response = await getUsersById(data);
      if (response?.status) {
        setUserData(response?.data?.result || []);
        const { firstName, lastName } = response?.data?.result[0];
        const fullName = `${firstName} ${lastName}`;
        localStorage.setItem("username", fullName);
      }
    } catch (err) {
      console.warn(err);
      setUserData([]); // Set to empty array on error
    }
  };

  useEffect(() => {
    if (getUserId) {
      getData(getUserId);
    }
  }, [getUserId]);
  // Listen for the custom event and refresh data when triggered
  useEffect(() => {
    const handleUserDataRefresh = () => {
      if (getUserId) {
        getData(getUserId);
      }
    };
    window.addEventListener("refreshUserData", handleUserDataRefresh);
    return () => {
      window.removeEventListener("refreshUserData", handleUserDataRefresh);
    };
  }, [getUserId]);

  const userRoles = JSON.parse(localStorage.getItem("user_roles"));

  return (
    <>
      <Grid>
        <Box
          // onMouseEnter={() => setShowProfileInfo(true)}
          // onMouseLeave={() => setShowProfileInfo(false)}
          sx={{
            // ...listItemStyles,
            p: 1,
            "&:hover": {
              borderRadius: "7px",
              background: "#0D4273",
            },
            "&.active": {
              background: "#0D4273",
              borderRadius: "7px",
            },
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <StyledBadge
            onMouseEnter={() => setShowProfileInfo(true)}
            onMouseLeave={() => setShowProfileInfo(false)}
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            variant="dot"
          >
            <Avatar
              sx={{
                bgcolor: "#085F99",
                width: 30,
                height: 30,
                cursor: "pointer",
              }}
              onClick={() => {
                // handleClose();
                navigate("/admin/info");
                setShowProfileHead(true);
              }}
              src={`${s.baseUrl}${userData[0]?.profilePicPath}`}
            />
          </StyledBadge>

          <Typography
            title={`${userData[0]?.firstName} ${userData[0]?.lastName}`}
            sx={{ fontSize: "15px", fontFamily: "Poppins", color: "white" }}
          >
            {userData[0]?.firstName}
            {/* {userData[0]?.lastName || "Name"} */}
          </Typography>
        </Box>
      </Grid>
    </>
  );
}
export default UserProfile;
const listItemStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
  textDecoration: "none",
};
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));
